import React from 'react';
import { Section } from './Section';
import { Leaf, Flame, HeartPulse, Crown } from 'lucide-react';
export function Modules() {
  const modules = [{
    icon: <Leaf className="w-6 h-6" data-id="element-136" />,
    title: 'Reconocer',
    content: 'Entender qué le pasa realmente a tu cuerpo y mente en el posparto',
    outcome: 'Dejas de sentir que "algo está mal contigo"'
  }, {
    icon: <Flame className="w-6 h-6" data-id="element-137" />,
    title: 'Reducir la inflamación',
    content: 'Guía específica para reducir hinchazón y recuperar energía',
    outcome: 'Te sientes más ligera y con más vitalidad'
  }, {
    icon: <HeartPulse className="w-6 h-6" data-id="element-138" />,
    title: 'Sanar emocionalmente',
    content: 'Herramientas para procesar el posparto emocional sin culpa',
    outcome: 'Recuperas tu paz mental y equilibrio emocional'
  }, {
    icon: <Crown className="w-6 h-6" data-id="element-139" />,
    title: 'Reconectar con tu identidad',
    content: 'Proceso para recordar quién eres más allá de ser mamá',
    outcome: 'Vuelves a sentirte tú misma de verdad'
  }, {
    icon: <div className="w-6 h-6" data-id="element-140" />,
    title: 'Renacer completa',
    content: 'Plan de acción para tu nueva versión como mujer y mamá',
    outcome: 'Vives el posparto desde el poder, no desde el agotamiento'
  }];
  return <Section className="bg-cream-light py-20" data-id="element-141">
      <div className="text-center mb-16" data-id="element-142">
        <h2 className="text-3xl md:text-4xl mb-4" data-id="element-143">
          Lo que encontrarás dentro de RENACIDA
        </h2>
        <div className="w-24 h-1 bg-rose/30 mx-auto rounded-full" data-id="element-144"></div>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8 max-w-6xl mx-auto" data-id="element-145">
        {modules.map((mod, index) => <div key={index} className={`bg-white rounded-3xl p-8 shadow-sm border border-cream-dark hover:shadow-md transition-shadow duration-300 ${index === 4 ? 'md:col-span-2 lg:col-span-1 lg:col-start-2' : ''}`} data-id="element-146">
            <div className="w-12 h-12 bg-cream rounded-full flex items-center justify-center text-sage mb-6" data-id="element-147">
              {mod.icon}
            </div>
            <h3 className="text-xl font-serif font-semibold mb-4 text-brown-dark" data-id="element-148">
              {mod.title}
            </h3>
            <p className="text-brown-light mb-6 min-h-[3rem]" data-id="element-149">{mod.content}</p>
            <div className="bg-rose/5 rounded-xl p-4 border border-rose/10" data-id="element-150">
              <p className="text-sm font-medium text-rose-dark uppercase tracking-wider mb-1 text-xs" data-id="element-151">
                Lo que logras:
              </p>
              <p className="text-brown font-medium" data-id="element-152">{mod.outcome}</p>
            </div>
          </div>)}
      </div>
    </Section>;
}